<template>
  <v-card class="mt-0" elevation="5" :loading="loading">
    <v-list-item three-line>
      <v-list-item-avatar tile size="80">
        <v-icon size="45" :class="colorBox">
          {{ iconBox }}
        </v-icon>
        <div class="mr-5">
          <v-progress-circular
            v-if="loading"
            color="primary"
            :size="50"
            :value="progressTxt"
            indeterminate
            class="vpc-calculos-perdas"
          >
            <label style="font-size: 10px">{{ progressTxt }}%</label>
          </v-progress-circular>
        </div>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="mb-0 text-h5">
          Cálculo de Perdas Técnicas:
          {{ statusTxt.charAt(0).toUpperCase() + statusTxt.slice(1) }}
        </v-list-item-title>
        <v-progress-linear :value="progress" :color="colorProgressLinear" />
        <v-list-item-subtitle>
          <span v-if="totalCalculos">
            {{ totalCalculosFinalizados | parseNumberToIntegerBR }} cálculos processados de um total de
            {{ totalCalculos | parseNumberToIntegerBR }}: {{ progressTxt }}%
          </span>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
  export default {
    props: {
      status: {
        type: String,
        default: 'AGUARDANDO'
      },
      calculos: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      statusTxt() {
        return this.status.toLowerCase();
      },
      iconBox() {
        switch (this.statusTxt) {
          case 'aguardando':
            return 'mdi-clock-outline';
          case 'sucesso':
            return 'mdi-check-bold';
          case 'executando':
            return null;
          default: {
            return 'mdi-alert';
          }
        }
      },
      colorBox() {
        switch (this.statusTxt) {
          case 'aguardando':
            return 'border-c-blue';
          case 'sucesso':
            return 'border-c-green';
          case 'executando':
            return 'border-c-primary';
          default: {
            return 'border-c-red';
          }
        }
      },
      colorProgressLinear() {
        switch (this.statusTxt) {
          case 'aguardando':
            return '#17a2b8';
          case 'sucesso':
            return '#438102';
          case 'executando':
            return '#003A63';
          default: {
            return 'red';
          }
        }
      },
      calculosFinalizados() {
        return this.calculos.filter((calculo) => ['SUCESSO', 'FALHA'].includes(calculo.status));
      },
      totalCalculos() {
        return this.calculos.length;
      },
      totalCalculosFinalizados() {
        return this.calculosFinalizados.length;
      },
      progress() {
        let progress = 0;
        if (this.totalCalculos) {
          progress = (this.totalCalculosFinalizados / this.totalCalculos) * 100;
        }
        return progress >= 100 ? 100 : progress;
      },
      progressTxt() {
        return this.progress.toFixed(2);
      },
      loading() {
        return this.statusTxt == 'executando' ? true : false;
      }
    }
  };
</script>

<style>
  .vpc-calculos-perdas div label {
    font-size: 8.5px !important;
  }
</style>
